module.exports = __webpack_public_path__ + "static/media/googlePlay.b397bfc8.svg";